// src/UIElements/Logs/LogsLogic.js
import { useEffect, useState } from 'react';
import LogsDS from '../../DataServices/LogsDs';
import { useCustomContext } from '../CustomComponents/CustomComponents';


export const LogLogic = () => {
  const logs = new LogsDS();
  const { showAlert, hud, stopHudRotation } = useCustomContext();

  const [logsByPage, setLogsByPage] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const [loadedPages, setLoadedPages] = useState([]);
  const [pageSize, setPageSize] = useState(25);
  const [isPageSizeEnabled, setIsPageSizeEnabled] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchLogsForPage = async (pageNum, limit = pageSize) => {
    if (loadedPages.includes(pageNum)) return;

    hud('Please Wait...');
    const offset = (pageNum - 1) * limit;

    try {
      const response = await logs.RM_Activity_Logs_GET({ limit, offset });
      const data = response.data;
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;

      if (data.statusCode === 200 && Array.isArray(body.records)) {
        setLogsByPage(prev =>
          pageNum === 1 ? { [pageNum]: body.records } : { ...prev, [pageNum]: body.records }
        );

        setLoadedPages(prev =>
          pageNum === 1 ? [pageNum] : prev.includes(pageNum) ? prev : [...prev, pageNum]
        );

        setHasMorePages(body.isMoreRecordsAvailable);
        setIsPageSizeEnabled(true);
        setTotalRecords(body.totalRecords);


      } else {
        const errorMessage = body?.message || 'Unexpected data format.';
        showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
      }
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
    } finally {
      stopHudRotation();
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    setLogsByPage({});
    setLoadedPages([]);
    setHasMorePages(true);

    fetchLogsForPage(1, pageSize);
  }, [pageSize]);

  const handlePageChange = async (pageNum) => {
    setCurrentPage(pageNum);
    if (!logsByPage[pageNum]) {
      await fetchLogsForPage(pageNum, pageSize);
    }
  };

  const getCurrentPageLogs = () => logsByPage[currentPage] || [];
  const totalPages = Math.max(...loadedPages, hasMorePages ? currentPage + 1 : currentPage);

  const startEntry = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;

  const endEntry = Math.min(currentPage * pageSize, totalRecords);

  const handlePageSizeChange = async (value) => {
    const newSize = Number(value);

    setPageSize(newSize);
    setCurrentPage(1);
    setLogsByPage({});
    setLoadedPages([]);
    setHasMorePages(true);
    setTotalRecords(0);

    fetchLogsForPage(1, newSize);
  };


  return {
    logs: getCurrentPageLogs(),
    currentPage,
    totalPages,
    handlePageChange,
    handlePageSizeChange,
    isPageSizeEnabled,
    pageSize,
    startEntry,
    endEntry,
    totalRecords
  }
};
